<template>
  <link-button
    :icon="icon"
    :size="size"
    :to="{ path: returnUrl }"
    :type="type"
    ref="button"
    v-if="returnUrl"
  >
    <slot>{{textOrDefault}}</slot>
  </link-button>
  <common-button
    :icon="icon"
    :size="size"
    :type="type"
    @click="$router.go(-1)"
    ref="button"
    v-else
  >
    <slot>{{textOrDefault}}</slot>
  </common-button>
</template>

<script>
import Button from '@/mixins/Button';
import CommonButton from '@/components/CommonButton';
import LinkButton from '@/components/LinkButton';

export default {
  name: 'cancel-button',
  mixins: [Button],
  components: {
    CommonButton,
    LinkButton,
  },
  computed: {
    textOrDefault() {
      return this.text || this.$t('actions.cancel');
    },
    returnUrl() {
      return this.$route.query.returnTo;
    },
  },
  i18n: {
    messages: {
      de: {
        actions: {
          cancel: 'Abbrechen',
        },
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// CancelButton.vue?a8229a5c